'use client';

import { useState } from 'react';
import type { MediaItem } from '@/lib/media';
import MediaCarousel from './MediaCarousel';
import Lightbox from './Lightbox';

interface VideoBlockProps {
  videos: string[];
  label: string;
}

/**
 * The standalone video block shown below the image strip. It keeps the existing
 * carousel (browse the clips as static posters), and clicking a clip opens it in
 * the lightbox — which here holds only the videos, so the counter reads e.g. 1/5
 * and the arrows move between videos. Videos never autoplay in the thumbnail.
 */
export default function VideoBlock({ videos, label }: VideoBlockProps) {
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);

  const items: MediaItem[] = videos.map((src) => ({ type: 'video', src }));

  return (
    <>
      <MediaCarousel
        slides={items}
        label={label}
        onOpen={(i) => {
          setIndex(i);
          setOpen(true);
        }}
      />

      <Lightbox
        items={items}
        index={index}
        open={open}
        label={label}
        onClose={() => setOpen(false)}
        onIndexChange={setIndex}
      />
    </>
  );
}
